module.exports = __webpack_public_path__ + "img/practicaImagen.5fa70de1.png";